import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

export default function Checklists() {
  const [templates, setTemplates] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = async () => setTemplates((await api.get("/onboarding/templates")).data);
  useEffect(() => { load(); }, []);

  const createNew = () => setEditing({
    name: "New template", kind: "onboarding", for_role: "",
    items: [{ label: "First item", owner_role: "Admin", due_offset_days: 0, required: true, tool: "" }],
  });

  const save = async () => {
    if (!editing.name) return toast.warning("Name required");
    if (editing.template_id) {
      await api.put(`/onboarding/templates/${editing.template_id}`, editing);
    } else {
      await api.post("/onboarding/templates", editing);
    }
    toast.success("Saved"); setEditing(null); load();
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Checklists</h1>
          <p className="text-sm text-[#A1A1AA] mt-1">Onboarding + offboarding templates with role-aware items.</p>
        </div>
        <button onClick={createNew} className="tt-btn-primary flex items-center gap-2"><Plus size={14} /> New template</button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {templates.map((t) => (
          <div key={t.template_id} className="tt-card p-4 cursor-pointer tt-card-hover" onClick={() => setEditing({ ...t })}>
            <div className="flex items-center justify-between">
              <div>
                <div className="font-medium">{t.name}</div>
                <div className="text-xs font-mono text-[#71717A]">{t.kind} · {t.for_role || "any role"}</div>
              </div>
              <span className="tt-badge-neutral">{t.items.length} items</span>
            </div>
          </div>
        ))}
        {templates.length === 0 && <div className="text-sm text-[#71717A]">No templates yet.</div>}
      </div>

      {editing && (
        <div className="fixed inset-0 bg-[rgba(10,10,10,0.85)] flex items-center justify-center z-40 p-4" onClick={() => setEditing(null)}>
          <div className="w-full max-w-2xl max-h-[90vh] overflow-y-auto tt-card p-6" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <input value={editing.name} onChange={(e) => setEditing({ ...editing, name: e.target.value })} className="tt-input text-lg w-80" />
              <div className="flex gap-2">
                <select value={editing.kind} onChange={(e) => setEditing({ ...editing, kind: e.target.value })} className="tt-input !w-auto">
                  <option value="onboarding">onboarding</option>
                  <option value="offboarding">offboarding</option>
                </select>
                <input value={editing.for_role || ""} onChange={(e) => setEditing({ ...editing, for_role: e.target.value })} placeholder="for role" className="tt-input !w-40" />
              </div>
            </div>
            <div className="space-y-2">
              {editing.items.map((it, idx) => (
                <div key={idx} className="grid grid-cols-12 gap-2 items-center">
                  <input value={it.label} onChange={(e) => { const n = [...editing.items]; n[idx].label = e.target.value; setEditing({ ...editing, items: n }); }} placeholder="Item" className="tt-input col-span-5" />
                  <input value={it.owner_role || ""} onChange={(e) => { const n = [...editing.items]; n[idx].owner_role = e.target.value; setEditing({ ...editing, items: n }); }} placeholder="Owner role" className="tt-input col-span-2" />
                  <input value={it.tool || ""} onChange={(e) => { const n = [...editing.items]; n[idx].tool = e.target.value; setEditing({ ...editing, items: n }); }} placeholder="Tool" className="tt-input col-span-2" />
                  <input type="number" value={it.due_offset_days} onChange={(e) => { const n = [...editing.items]; n[idx].due_offset_days = parseInt(e.target.value || 0); setEditing({ ...editing, items: n }); }} className="tt-input col-span-2 font-mono" />
                  <button onClick={() => setEditing({ ...editing, items: editing.items.filter((_, i) => i !== idx) })} className="tt-btn-ghost col-span-1"><Trash2 size={14} /></button>
                </div>
              ))}
              <button onClick={() => setEditing({ ...editing, items: [...editing.items, { label: "New item", owner_role: "Admin", due_offset_days: 0, required: true, tool: "" }] })} className="tt-btn-secondary text-xs flex items-center gap-1"><Plus size={12} /> Add item</button>
            </div>
            <div className="flex justify-end gap-2 mt-6">
              <button onClick={() => setEditing(null)} className="tt-btn-secondary text-sm">Cancel</button>
              <button onClick={save} className="tt-btn-primary text-sm">Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
